var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopRailWaltti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 21H9.6A1.6 1.6 0 0 1 8 19.4V6.6A1.6 1.6 0 0 1 9.6 5h12.8A1.6 1.6 0 0 1 24 6.6v12.8a1.6 1.6 0 0 1-1.6 1.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.652 14.892V9.71c0-1.113-.903-3.11-2.016-3.11h-5.272c-1.113 0-2.015 1.997-2.015 3.11v5.182c0 1.113.902 2.563 2.015 2.563h.117l-.496.592h-.862l-.547.584h.919l-.645.77h1.187l.645-.77h4.636l.644.77h1.188l-.645-.77h.918l-.547-.584h-.86l-.496-.592h.116c1.113 0 2.016-1.45 2.016-2.563m-1.369.627a.594.594 0 1 1 0-1.188.594.594 0 0 1 0 1.188M14.276 7.84h3.447v.584h-3.446zm-1.559 7.679a.593.593 0 1 1 0-1.187.593.593 0 0 1 0 1.187m-.364-2.47a.31.31 0 0 1-.23-.3V9.642a.31.31 0 0 1 .31-.31h7.133a.31.31 0 0 1 .31.31v3.108a.31.31 0 0 1-.23.3c-.54.145-1.973.263-3.647.263s-3.106-.119-3.646-.264m5.476 4.999H14.17l.497-.593h2.665z"
})));
export { SvgStopRailWaltti as ReactComponent };